// src/store/index.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    simulations: [
      { id: 1, title: 'Законы Ньютона', description: 'Симуляция законов Ньютона' },
      { id: 2, title: 'Маятник', description: 'Движение маятника' },
      { id: 3, title: 'Оптика', description: 'Оптика' },
    ],
  },
  getters: {
    getSimulationById: (state) => (id) => state.simulations.find(sim => sim.id === id),
  },
});
